import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UpdateApplicationRequestStatus } from '@nucleus-commerce/api-client/platform';

import { applicationsApi } from '../api/applications-api';

import { applicationKeys } from './application-keys';

/** Mark contacted or withdrawn. 409 CONFLICT (wrong status) is toasted by the global policy. */
export function useUpdateApplicationStatus(id: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (status: UpdateApplicationRequestStatus) => applicationsApi.update(id, { status }),
    meta: { successMessage: 'applications:toasts.updated' },
    onSuccess: (application) => {
      queryClient.setQueryData(applicationKeys.detail(id), application);
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: applicationKeys.lists() }),
        queryClient.invalidateQueries({ queryKey: applicationKeys.counts() }),
      ]);
    },
  });
}
